<template>
    <div class="space-y-6 bg-white rounded-md shadow-sm border border-gray-200">
        <div class="sm:col-span-6 sm:flex justify-between items-center border-b border-gray-200 py-4 px-4">
            <div>
                <h4 class="text-xl font-bold text-gray-700 sm:text-2xl sm:truncate">Vehicle Information</h4>
                <p class="text-sm text-gray-500">Please provide information about your vehicles.</p>
            </div>
            <button type="button" class="primaryButton whitespace-nowrap" @click="addVehicle()"><font-awesome-icon :icon="faPlus" class="pr-2 pt-1"></font-awesome-icon> Vehicle </button>
        </div>
        <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 p-4 pt-0">
            <div class="sm:col-span-6">
                <div class="flow-root">
                    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-300">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Model</th>
                                        <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Year</th>
                                        <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Color</th>
                                        <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                            <span class="sr-only">Remove</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-200 bg-white">
                                    <tr v-for="(vehicle, index) in form.vehicles" :key="vehicle.key" class="hover:bg-gray-50">
                                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 sm:pl-6">
                                            <input v-model="vehicle.model" type="text" class="shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md">
                                            <p v-if="form.errors[`vehicles.${vehicle.key}.model`]"
                                                class="text-red-500 text-sm">
                                                {{ form.errors[`vehicles.${vehicle.key}.model`] }}
                                            </p>
                                        </td>
                                        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                            <input v-model="vehicle.year" type="text" class="shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md">
                                            <p v-if="form.errors[`vehicles.${vehicle.key}.year`]"
                                                class="text-red-500 text-sm">
                                                {{ form.errors[`vehicles.${vehicle.key}.year`] }}
                                            </p>
                                        </td>
                                        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                            <input v-model="vehicle.color" type="text" class="shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md">
                                            <p v-if="form.errors[`vehicles.${vehicle.key}.color`]"
                                                class="text-red-500 text-sm">
                                                {{ form.errors[`vehicles.${vehicle.key}.color`] }}
                                            </p>
                                        </td>
                                        <td class="whitespace-nowrap px-3 py-4 text-gray-500">
                                            <button v-if="form.vehicles.length > 1" type="button" class="inline-flex justify-center py-2 px-3 border border-red-500 shadow-sm text-sm font-medium rounded-md text-red-500 bg-white disabled:bg-red-300 hover:bg-red-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" @click="removeVehicle(index)">
                                                <font-awesome-icon :icon="faTrash" class="h-4 w-4" />
                                            </button>
                                            <button v-else type="button" disabled="disabled" class="inline-flex justify-center py-2 px-3 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-500 bg-white disabled:bg-gray-100 hover:bg-gray-50 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 cursor-not-allowed">
                                                <font-awesome-icon :icon="faTrash" class="h-4 w-4" />
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="applicant_type.type === 'main'">
        <div id="agentInformation" class="space-y-6 bg-white rounded-md shadow-sm border border-gray-200 mt-6">
            <div class="sm:col-span-6 sm:flex justify-between items-center border-b border-gray-200 py-4 px-4">
                <div>
                    <h4 class="text-xl font-bold text-gray-700 sm:text-2xl sm:truncate">Your Agent</h4>
                    <p class="text-sm text-gray-500">Please provide information about your agent (optional).</p>
                </div>
            </div>
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 p-4 pt-0">
                <div class="sm:col-span-3">
                    <label for="name_agent_representing" v-bind:class="(form.errors.name_agent_representing)?'block text-sm font-medium text-red-500':'block text-sm font-medium text-gray-700'">
                        Name of Agent Representing You
                    </label>
                    <div class="mt-1">
                        <input id="name_agent_representing" v-model="form.name_agent_representing" :error="form.errors.name_agent_representing" type="text" v-bind:class="(form.errors.name_agent_representing)?'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-red-300 rounded-md':'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md'">
                        <p v-text="form.errors.name_agent_representing" class="text-red-500 text-sm"></p>
                    </div>
                </div>
                <div class="sm:col-span-3">
                    <label for="email_agent_representing" v-bind:class="(form.errors.email_agent_representing)?'block text-sm font-medium text-red-500':'block text-sm font-medium text-gray-700'">
                        Email of Agent Representing You
                    </label>
                    <div class="mt-1">
                        <input id="email_agent_representing" v-model="form.email_agent_representing" :error="form.errors.email_agent_representing" type="text" v-bind:class="(form.errors.email_agent_representing)?'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-red-300 rounded-md':'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md'">
                        <p v-text="form.errors.email_agent_representing" class="text-red-500 text-sm"></p>
                    </div>
                </div>
            </div>
        </div>
        <div id="additionalApplicants" class="space-y-6 bg-white rounded-md shadow-sm border border-gray-200 mt-6">
            <div class="sm:col-span-6 sm:flex justify-between items-center border-b border-gray-200 py-4 px-4">
                <div>
                    <h4 class="text-xl font-bold text-gray-700 sm:text-2xl sm:truncate">Additional Applicants</h4>
                    <p class="text-sm text-gray-500">Add names and email addresses below for any additional applications 18 years and older.</p>
                    <p class="text-sm text-gray-500">Each person below will receive an email to apply and will be linked with your account making it easier for the agent/landlord to review your applications together.</p>
                </div>
                <button type="button" class="primaryButton whitespace-nowrap" @click="addAdditionalApplicant()">
                    <font-awesome-icon :icon="faPlus" class="pr-2 pt-1"></font-awesome-icon> Additional Applicant
                </button>
            </div>
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 p-4 pt-0">
                <div class="sm:col-span-6">
                    <div class="flow-root">
                        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                                    <!--v-show="form.additional_applicants.length > 0"-->
                                    <table class="min-w-full divide-y divide-gray-300">
                                        <thead class="bg-gray-50">
                                        <tr>
                                            <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Name</th>
                                            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Email Address</th>
                                            <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                                <span class="sr-only">Remove</span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-200 bg-white">
                                        <tr v-for="(row, index) in form.additional_applicants" :key="index" class="hover:bg-gray-50">
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 sm:pl-6">
                                                <input :id="'additional_applicants_name_'+index" :key="'additional_applicants.name'" v-model="form.additional_applicants[index].name" :error="form.errors.additional_applicants" type="text" v-bind:class="form.errors[`additional_applicants.${index}.name`]?'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-red-300 rounded-md':'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md'">
                                                <p v-if="form.errors[`additional_applicants.${index}.name`]" class="text-red-500 text-sm">
                                                    {{ form.errors[`additional_applicants.${index}.name`] }}
                                                </p>
                                            </td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                <input :id="'additional_applicants_email_'+index" :key="'additional_applicants.email'" v-model="form.additional_applicants[index].email" :error="form.errors.additional_applicants" type="email" v-bind:class="form.errors[`additional_applicants.${index}.email`]?'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-red-300 rounded-md':'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md'">
                                                <p v-if="form.errors[`additional_applicants.${index}.email`]" class="text-red-500 text-sm">
                                                    {{ form.errors[`additional_applicants.${index}.email`] }}
                                                </p>
                                            </td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                <button v-if="form.additional_applicants.length > 1" type="button" class="inline-flex justify-center py-2 px-3 border border-red-500 shadow-sm text-sm font-medium rounded-md text-red-500 bg-white disabled:bg-red-300 hover:bg-red-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" @click="removeAdditionalApplicant(index)">
                                                    <font-awesome-icon :icon="faTrash" class="h-4 w-4" />
                                                </button>
                                                <button v-else type="button" disabled="disabled" class="inline-flex justify-center py-2 px-3 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-500 bg-white disabled:bg-gray-100 hover:bg-gray-50 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 cursor-not-allowed">
                                                    <font-awesome-icon :icon="faTrash" class="h-4 w-4" />
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="petsInformation" class="space-y-6 bg-white rounded-md shadow-sm border border-gray-200 mt-6">
            <div class="sm:col-span-6 sm:flex justify-between items-center border-b border-gray-200 py-4 px-4">
                <div>
                    <h4 class="text-xl font-bold text-gray-700 sm:text-2xl sm:truncate">Animals</h4>
                    <p class="text-sm text-gray-500">Please provide information about your animals.</p>
                </div>
            </div>
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 p-4 pt-0">
                <div class="sm:col-span-3">
                    <div class="mt-1">
                        <textarea id="pets" rows="10" v-model="form.pets" :error="form.errors.pets" v-bind:class="(form.errors.pets)?'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-red-300 rounded-md':'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md'">
                        </textarea>
                        <p v-text="form.errors.pets" class="text-red-500 text-sm"></p>
                    </div>
                </div>
                <div class="sm:col-span-3">
                    <p class="text-gray-500 text-sm">List all animals that will be living in the property. Include the following information:</p>
                    <ul role="list" class="list-disc space-y-1 pl-5 mt-4 text-gray-500 text-sm">
                        <li>Type of Animal</li>
                        <li>Breed</li>
                        <li>Weight</li>
                        <li>Age</li>
                    </ul>
                </div>
            </div>
        </div>
        <div id="additionalOccupants" class="space-y-6 bg-white rounded-md shadow-sm border border-gray-200 mt-6">
            <div class="sm:col-span-6 sm:flex justify-between items-center border-b border-gray-200 py-4 px-4">
                <div>
                    <h4 class="text-xl font-bold text-gray-700 sm:text-2xl sm:truncate">Additional Occupants</h4>
                    <p class="text-sm text-gray-500">Please provide information about your additional occupants.</p>
                </div>
            </div>
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 p-4 pt-0">
                <div class="sm:col-span-3">
                    <div class="mt-1">
                        <textarea id="additional_occupants" rows="10" v-model="form.additional_occupants" :error="form.errors.additional_occupants" v-bind:class="(form.errors.additional_occupants)?'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-red-300 rounded-md':'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md'">
                        </textarea>
                        <p v-text="form.errors.additional_occupants" class="text-red-500 text-sm"></p>
                    </div>
                </div>
                <div class="sm:col-span-3">
                    <p class="text-gray-500 text-sm">List all persons who will reside in the property. Include the following for all ages:</p>
                    <ul role="list" class="list-disc space-y-1 pl-5 mt-4 text-gray-500 text-sm">
                        <li>Name</li>
                        <li>Age</li>
                        <li>Relationship to you</li>
                    </ul>
                </div>
            </div>
        </div>
        <div id="additionalInformationOther" class="space-y-6 bg-white rounded-md shadow-sm border border-gray-200 mt-6">
            <div class="sm:col-span-6 sm:flex justify-between items-center border-b border-gray-200 py-4 px-4">
                <div>
                    <h4 class="text-xl font-bold text-gray-700 sm:text-2xl sm:truncate">Additional Information</h4>
                    <p class="text-sm text-gray-500">Add any notes or information here that you would like to share with the landlord or listing agent.</p>
                </div>
            </div>
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 p-4 pt-0">
                <div class="sm:col-span-6">
                    <div class="mt-1">
                        <textarea
                            id="additional_information"
                            rows="10" v-model="form.additional_information"
                            :error="form.errors.additional_information"
                            placeholder="Add any notes or information here that you would like to share with the landlord or listing agent"
                            v-bind:class="(form.errors.additional_information)?'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-red-300 rounded-md':'shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md'"
                        >
                        </textarea>
                        <p v-text="form.errors.additional_information" class="text-red-500 text-sm"></p>
                    </div>
                </div>
            </div>
        </div>
    </div> <!-- END OF MAIN APPLICANT-->
    <div v-if="applicant_type.type !== 'main'" class="space-y-6 bg-white rounded-md shadow-sm border border-gray-200 mt-6">
        <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 p-4 pt-0">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="sm:col-span-2">
                    <h4 class="text-xl font-bold text-gray-700 sm:text-2xl sm:truncate">
                        Main Applicant :
                    </h4>
                </div>
                <div class="sm:col-span-4">
                    <h4 class="text-xl font-bold text-gray-700 sm:text-2xl sm:truncate">
                        {{ applicant_type.name }} : {{ applicant_type.email }}
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTrash, faPlus } from '@fortawesome/pro-solid-svg-icons';

export default {
    components: {
        FontAwesomeIcon
    },
    props: {
        form: Object,
        application: Object,
        states: Object,
        validateField: Function,
        applicant_type: Object
    },
    data() {
        return {
            faTrash,
            faPlus
        }
    },
    methods: {
        addVehicle() {
            this.form.vehicles.push({ key: Date.now(), model: '', year: '', color: '' });
        },
        removeVehicle(index) {
            this.form.vehicles.splice(index, 1);
        },
        addAdditionalApplicant() {
            this.form.additional_applicants.push({ name: '', email: '' });
        },
        removeAdditionalApplicant(index) {
            this.form.additional_applicants.splice(index, 1);
        }
    }
}
</script>